import { useMemo } from "react";
import { useCustomQuery } from "data/modules/api/hooks/useCustomQuery";
import {
  MEMBERSHIP_API_PATHNAME,
  MEMBERSHIP_APIS,
} from "../../constants/Membership.apis";
import { COMMUNITY_CUSTOM_LINK_LIST_RESPONSE_KEY } from "../../constants/MembershipsSection.data";
import { useMembershipStore } from "../../store/useMembershipStore";

/**
 * Fetches all community custom links available for membership mapping in the dropdown.
 */
export const useCommunityCustomLinkOptions = ({ enabled = false } = {}) => {
  const listingId = useMembershipStore((state) => state.listingId);

  const { data: communityCustomLinkList } = useCustomQuery({
    queryKey: [MEMBERSHIP_APIS.getCustomLinkList, listingId],
    url: MEMBERSHIP_API_PATHNAME.getCustomLinkList({ listingUuid: listingId }),
    enabled: enabled && !!listingId,
  });

  const customLinkOptionList = useMemo(() => {
    return (
      communityCustomLinkList?.[COMMUNITY_CUSTOM_LINK_LIST_RESPONSE_KEY] || []
    );
  }, [communityCustomLinkList]);

  return { customLinkOptionList };
};
